<template>
  <div class="divNavBar" :class="{ searchNavBar: flag }">
    <div class="divRightMenu">
      <div class="divLogo">
        <img src="./../../assets/logo_v3.png" width="176px" @click="jumpToIndex" />
      </div>
      <div class="labelTop">
        <div v-for="(item, index) in navListData[clstag]" :key="index" :class="{act: setActCalss(index)}"
          v-track="[ item.name, '文字点击' ]"> 
            <router-link target="_blank" @click.native="update(item, index)" :to="item && item.routerName !== null ? `${item.routerName}` : `/detail`">
            {{ item.name }}
            </router-link>
          </div>
      </div>
      <div class="divContent">
        <ul :class="{ divUl: flag }">
          <div class="tagCont">
              <!-- <li><a target="_blank" href="http://www.itcast.cn/"> 传智教育 </a></li> -->
              <li @click="routerHandle('/bishe')" :class="{labact: clstag === 1}">毕业设计站</li>
          </div>
          <!-- 添加版本信息路径 -->
          <div class="edition">
            <div
              v-if="$store.state.toggleImg === false"
              class="log"
              @click="changeToggleImg"
            >
              <img
                style="text-align:center;"
                class="img-1"
                src="../../assets/log_v3.png"
                alt="版本信息"
              />
              <img
                style="text-align:center;"
                class="img-2"
                src="../../assets/log_v3_hover.png"
                alt="版本信息"
                @click="changeToggleImg"
              />
              <!-- 版本信息 -->
              <div class="info-div">
                <p>更新日志</p>
              </div>
            </div>
            <div
              v-else
              style="width: 30px;height:30px;display: flex;justify-content: center;padding-top: 24px;box-sizing: border-box;"
            >
              <img class="img-3" src="../../assets/log_v3.png" alt="版本信息" />
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import { Contents } from "../../graphql/Contents.gql";
// import { Categories } from "../../graphql/Categories.gql"
// import pageElement from "./../pages/home/common/pageElement";
export default {
  props: {
    position: {
      type: String,
      default: "center",
    },
    onIndex: {
      type: Number,
      default: 0
    }
  },
   components: {
    // pageElement,
  },
  data() {
    return {
      toggleNavImg: false,
      items: [], //返回的菜单数据
      selectItems: [], //处理之后的数据
      msg: "",
      flag: false,
      clstag: 0,
      pagetag: 110,
      menuDatas: [],
      navListData: [[
        {
          id: "0",
          name: "首页",
          routerName: "/home",
        },
        {
          id: "1",
          name: "Java",
          routerName: "/java",
        },
        {
          id: "2",
          name: "前端",
          routerName: "/web",
        },
        {
          id: "7",
          name: "Python+大数据",
          routerName: "/bigdata",
        },
        {
          id: "8",
          name: "人工智能",
          routerName: "/ai",
        },
        // {
        //   id: "3",
        //   name: "Python",
        //   routerName: "/python",
        // },
        {
          id: "9",
          name: "新媒体",
          routerName: "/nm",
        },
        {
          id: "6",
          name: "设计",
          routerName: "/ui",
        },
        {
          id: "5",
          name: "产品经理",
          routerName: "/pm",
        },
        {
          id: "4",
          name: "测试",
          routerName: "/testHome",
        },
      ],
      [{id:0, routerName: '/bishe', name: '毕设首页'}],
      [{id:1, routerName: 'http://java.itcast.cn/?javaeezly', name: 'Java'},
       {id:2, routerName: 'http://web.itcast.cn/', name: '前端'},
       {id:3, routerName: 'http://cloud.itcast.cn/', name: 'Python+大数据'},
       {id:4, routerName: 'http://python.itcast.cn', name: 'python+数据分析'},
       {id:5, routerName: 'http://ai.itcast.cn', name: '人工智能'},
       {id:6, routerName: 'http://www.itcast.cn/subject/uizly/', name: 'UI/UE设计'},
       {id:7, routerName: 'http://test.itcast.cn/', name: '软件测试'},
       {id:8, routerName: 'http://www.itcast.cn/subject/pmzly/', name: '产品经理'},
      ]],
      linkData: [
        { desc: "传智教育", url: "http://itcast.cn/" },
        { desc: "Java", url: "/java" },
        // { desc: "传智研究院", url: "http://czri.itcast.cn/" },
      ],
      subjectID: "",
      subjectData: [
        {
          subjectID: "1",
          desc: "Java",
          url: "http://java.itcast.cn/?javaeezly",
        },
        {
          subjectID: "2",
          desc: "前端",
          url: "http://web.itcast.cn/?webzly",
        },
        {
          subjectID: "7",
          desc: "Python+大数据",
          url: "http://cloud.itcast.cn/?cloudzly",
        },
        {
          subjectID: "3",
          desc: "python+数据分析",
          url: "http://python.itcast.cn/",
        },
        {
          subjectID: "8",
          desc: "人工智能",
          url: "http://ai.itcast.cn/?aizly$javaeezly",
        },
        
        {
          subjectID: "6",
          desc: "UI/UE设计",
          url: "http://www.itcast.cn/subject/uizly/index.shtml",
        },
        {
          subjectID: "4",
          desc: "测试",
          url: "http://test.itcast.cn/?testzly",
        },
        {
          subjectID: "5",
          desc: "产品经理",
          url: "http://www.itcast.cn/subject/pmzly/index.html",
        },
      ],
    };
  },
  mounted() {
    // let url = this.$router.currentRoute.path
    // if (url === '/bishe'){
    //   this.clstag = 1
    // }
    let subjectID = sessionStorage.getItem("subjectID")
      ? sessionStorage.getItem("subjectID")
      : "1";
    this.subjectID = subjectID;
    // let arr = this.linkData.concat(
    //   this.subjectData.filter((item) => item.subjectID === subjectID)
    // );
    // this.linkData = arr;
    this.getSelectItems();
  },
  created() {
    window.addEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        this.enterClick();
      }
    });
    this.storageTest();
    this.getNavData()
  },
  beforeDestroy() {
    window.removeEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        this.enterClick();
      }
    });
  },
  methods: {
    changeToggleImg() {
      sessionStorage.setItem("subjectID", "0");
      this.$router.push("/homeUpdate");
      this.$store.commit("updateToggleImg", true);
    },
    navbarmouseLeave(){
      let url = this.$router.currentRoute.path
      if (url == '/bishe'){
        this.clstag = 1
        // this.onIndex = 100
      } else {
        this.clstag = 0
      }
    },
    searchClick() {
      this.$trackEvent("检索放大镜", "点击图标");
      this.flag = !this.flag;
      if (this.flag) {
        this.$nextTick(() => {
          this.$refs.inputSearch.focus();
        });
      }
    },
    linkClick(item) {
      // this.$trackEvent('传智教育', '点击文字', item.desc)
      this.$trackEvent(item.desc, "点击文字", item.desc);
      if (item.url === '/java'){
        window.open(item.url, "_blank");
        // this.$router.push(item.url)
      } else {
        window.open(item.url, "_blank");
      }
    },
    routerHandle(url){
      // this.$router.push(url)
      window.open(url, "_blank");
      this.$store.commit("updateToggleImg", false);
    },
    jumpToIndex() {
      sessionStorage.setItem("subjectID", "1");
      // this.$router.push("/home");
      window.open("/home", "_blank");
      this.$trackEvent("顶部研究院图标", "点击图标");
      this.$store.commit("updateToggleImg", false);
    },
    getSelectItems() {
      let params = {
        isPublish: true,
      };
      //Todo 将数据放到vuex中
      params.subjectID = this.subjectID;
      // this.$apollo
      //   .query({
      //     query: Contents,
      //     variables: params,
      //   })
      //   .then((res) => {
      //     this.items = res.data.pContents;
      //     this.dataFormat();
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    dataFormat() {
      let items = this.items;
      let arr = [];
      items.forEach((item) => {
        arr.push({
          value: item.name,
          router: item.router,
          type: item.p_template ? item.p_template.code : undefined,
          id: item.id,
        });
      });
      this.selectItems = arr;
    },
    querySearch(queryString, cb) {
      let selectItems = this.selectItems;
      let results = queryString
        ? selectItems.filter(this.createFilter(queryString))
        : selectItems;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (item) => {
        return item.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
      };
    },
    handleSelect(item) {
      this.$trackEvent("搜索输入", "输入值");
      if (item) {
        let path;
        if (item.router) {
          //java学科
          path = item.router;
        } else if (item.type) {
          path = item.type;
        } else {
          path = "/details";
        }
        sessionStorage.setItem("detailsId", item.id);
        let routeData = this.$router.resolve({
          path: path,
        });
        window.open(routeData.href, "_blank");
      }
    },
    enterClick() {
      let ulEle = document.querySelector(".el-scrollbar");
      if (ulEle) {
        let liEle = ulEle.querySelector("li");
        if (liEle) {
          let value = liEle.innerText;
          let selectItems = this.selectItems;
          let firstItem;
          if (value) {
            selectItems.forEach((item) => {
              if (item.value === value) {
                firstItem = item;
                return;
              }
            });
          }
          if (firstItem) {
            this.handleSelect(firstItem);
          }
        }
      }
    },
    storageTest() {
      sessionStorage.setItem("storageTest", "value");
      if (!sessionStorage.getItem("storageTest")) {
        alert("您的浏览器处于无痕模式,请退出无痕模式后再重新打开本页面");
      }
      sessionStorage.removeItem("storageTest");
    },
    clsHandle(tg){
      this.clstag = tg
    },
    setActCalss(index){
      const navIndex = sessionStorage.getItem("navIndex");  // item.id
      const url = this.$router.currentRoute.path
      if (url === '/homeUpdate') {
        return false
      }
      if (this.clstag == 0 && url != '/bishe') {
        return index == navIndex //this.onIndex
      } else if (this.clstag == 1 && url === '/bishe'){
        return true
      }else {
        return false
      }
    },
    update () {
      // window.open(item.routerName, "_blank");
      // this.$store.commit("updateToggleImg", false)
      // window.sessionStorage.setItem("subjectID", String(item.id))
    },
    getNavData () {
      // this.$apollo.query(
      //   {
      //     query: Categories,
      //     variables: {
      //       isPublish: true
      //     }
      //   })
      //   .then((res) => {
      //     this.menuDatas = res.data.pCategories.slice(0, 8)
      //     // this.navListData[0]=this.menuDatas
      //     // console.log(this.menuDatas)
      //     this.$forceUpdate();
      //   })
      //   .catch(() => {
      //   })
    }
  },

};
</script>
<style scoped>
  @media screen () {
    
  }
</style>
<style lang="scss" scoped>
.divNavBar {
  width: 100%;
  height: 63px;
  line-height: 63px;
  width: 100%;
  min-width: 1180px;
  transition: all 1s;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 7%);
  position: relative;
  z-index: 9;
  .divRightMenu {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    // top: 20px;
    width: calc(100% - 90px);
    .divContent {
      .tagCont{
         position: relative;
         display: flex;
         padding-right: 15px;
         &::after{
            content: '';
            position: absolute;
            right: 0px;
            top:50%;
            transform: translateY(-50%);
            height: 15px;
            border-right:solid 1px #f4f4f4;
            width: 1px;
         }
      }
      ul {
        display: flex;
        li {
          position: relative;
          margin-left: 30px;
          cursor: pointer;
          // height: 20px;
          font-size: 14px;
          // font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #19232b;
          // line-height: 20px;
          white-space: nowrap;
          min-width: 30px;
          .sousuo {
            width: 15px;
            height: 15px;
            position: absolute;
            left: 8px;
            top: 5px;
            img {
              width: 15px;
              height: 15px;
            }
          }
          .divClose {
            width: 15px;
            position: absolute;
            top: 5px;
            right: 0px;
            img {
              width: 15px;
            }
          }
          &:first-child {
            margin-left: 0;
          }
          &divLeftMenu {
            margin-left: 20px;
          }
        }
        // li:hover {
        //   color: #1286FF;
        // }
        .liLast {
          margin-right: 0px;
        }
      }
      .divUl {
        width: auto;
      }
    }
  }
  .divLogo {
    img {
      vertical-align: middle;
      cursor: pointer;
    }
  }
  // .divLeftMenu {
  //   position: absolute;
  //   top: 20px;
  //   left: 80px;
  // }
  .labelTop{
    display: flex;
    justify-content: center;
    div{
      cursor: pointer;
      padding: 0 20px;
      a{font-size: 14px;}
      // font-weight: 600;
    }
    .labact{
      position: relative;
      color: #1286ff;
      &::before{
        content: "";
        position: absolute;
        width: 15px;
        height: 15px;
        border-top:solid 1px #ccc;
        border-right:solid 1px #ccc;
        transform: rotateZ(-45deg) translateX(-50%);
        left: 50%;
        bottom: -33px;
        background: #fff;
      }
    }
     .act{
      font-weight: bold !important;
      position: relative;
      a,a:hover{
        color: #1286FF;
      }
      &::before{
        content: '';
        position: absolute;
        width: 30px;
        height: 2px;
        bottom: 15px;
        
        left: 50%;
        transform: translateX(-50%);
        background: #1286FF;
      }
    }
  }
}
.navBarLink{
    line-height: 50px;
    border-top: solid 1px #ccc;
    background: #fff;
    text-align: center;
    .navBarItem{
      width: calc(100% - 398px);
      text-align: left;
      display: flex;
      padding-left: 398px;
      padding-right: 0;
    }
    div{
      padding: 0 25px;
      font-size: 12px;
      color: #333;
      cursor: pointer;
      :hover{
        color:#1286FF;
      }
    }
  }
.searchNavBar {
  background-color: #fafafa;
  transition: all 1s;
}

.edition {
  // margin-left: 42px;
  margin-left: 6px;
  margin-right: 4px;
  .log{
      width: 30px;
      height:30px;
      display: flex;
      justify-content: center;
      padding-top: 24px;
      box-sizing: border-box;
    }
  div {
    img {
      cursor: pointer;
      width: 15px;
      height: 15px;
    }
    .img-1 {
      display: block;
    }
    .img-2 {
      display: none;
    }
    .info-div {
      display: none;
      width: 59px;
      height: 20px;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
      position: absolute;
      right: 0;
      bottom: -12px;
      p {
        text-align: center;
        width: 100%;
        font-size: 12px;
        font-family:  "PingFangSC", "MicrosoftYaHei", "PingFangSC-Regular";
        font-weight: 300;
        color: #19232b;
        line-height: 20px;
      }
    }
    .img-3 {
      cursor: pointer;
      width: 15px;
      height: 15px;
    }
  }
  div:hover {
    .img-1 {
      display: none;
    }
    .img-2 {
      display: block;
      transform: scale(1.2);
    }
    .info-div {
      display: block;
    }
  }
}
</style>
<style lang="scss">
.divNavBar {
  position: relative;
  z-index: 9;
  line-height: 63px;
  .divRightMenu {
    .divContent {
      // padding-top: 12px;
      li {
        .el-autocomplete {
          top: -5px;
          .el-input__inner {
            border-radius: 0;
            border-top: 0;
            border-left: 0;
            border-right: 0;
            width: 507px;
            height: 32px;
            border-bottom: 1px solid #bbbbbb;
            padding-left: 22px;
            background-color: initial;
          }
        }
      }
    }
  }
}

.el-tooltip__popper {
  padding: 8px 10px;
  margin-right: 0px;
}
</style>
